import { Box, Image, Text } from "@chakra-ui/react";
import VisionImage from "../images/VisionAboutPage.png";
import MissionIcon from "../images/MissionIcon.png";
import pallavi from "../images/PallaviSuit.png";
import image2 from "../images/image2.jpeg";
import office from "../images/sonam office.png";
import sonam_agro from "../images/sonam_agro.jpg";

const missions = [
  {
    title: "Mission 1",
    bg: "rgba(3, 54, 255, 0.35)",
    text: `Empower Farmers through Innovation — We aim to design and deliver smart, user-friendly agri-tech solutions that simplify daily farming activities, enhance crop productivity, and make innovation reachable for every farmer, regardless of scale or location.`,
  },
  {
    title: "Mission 2",
    bg: "rgba(255, 100, 26, 0.31)",
    text: `Promote Sustainable and Eco-Friendly Farming — Our mission is to encourage responsible farming practices that conserve natural resources, improve soil health, and reduce harmful inputs, ensuring harmony between nature and agriculture.`,
  },
  {
    title: "Mission 3",
    bg: "rgba(78, 203, 113, 0.35)",
    text: `Strengthen Rural Economies and Livelihoods — We are committed to uplifting rural communities by offering training, digital connectivity, and fair market access, helping farmers build resilient, long-term income sources.`,
  },
];
const About = () => {
  return (
    <>
      <Box
        padding={["10px", "40px"]}
        background="linear-gradient(180deg, #F3FFE1 0%, #FBFFF6 100%)"
        textAlign={"justify"}
      >
        <Box
          display={"grid"}
          gridTemplateColumns={[
            "1fr",
            "1fr",
            "1fr",
            "repeat(2,1fr)",
            "repeat(2,1fr)",
          ]}
          gap="40px"
        >
          <Box>
            <Text
              color={"#404040"}
              fontFamily="Inter"
              fontSize={["20px", "32px", "42px", "52px", "52px"]}
              fontWeight="700"
            >
              About Our Company{" "}
            </Text>
            <Text
              fontSize={["20px", "32px", "42px", "52px", "52px"]}
              color="#52771A"
              fontFamily="Inter"
              // fontSize={"52px"}
              fontWeight="700"
            >
              Sonam
            </Text>

            <Text
              color="#000"
              fontFamily="Inter"
              fontSize={["10px", "24px"]}
              fontWeight="400"
              width={["auto", "auto", "auto", "598px", "598px"]}
              mt={["10px", "33px"]}
            >
              We’re here to revolutionize the farming industry using the modern
              technology and tools.
            </Text>
          </Box>
          <Box>
            <Image src={office} width={"100%"} height={["200px", "366px"]} />
          </Box>
        </Box>
        <Box mt={["10px", "20px"]}>
          <Image src={sonam_agro} width={"100%"} height={["200px", "366px"]} />
        </Box>
        <Box mt={"25px"}>
          <Text fontSize={["10px", "16px"]}>
            Founded in 2021, Sonam Agrotech Private Limited has rapidly emerged
            as a key player in the agricultural sector, specializing in the
            trading of fertilizers and agrochemical products. With its
            registered office located in Bihar, India, the company is steadfast
            in its commitment to delivering high-quality agricultural solutions
            to farmers, ensuring the enhancement of productivity and
            sustainability in farming practices. Sonam Agrotech stands out for
            its comprehensive range of products and services designed to meet
            the diverse needs of farmers. The company's core offerings include:
            Sonam Agrotech provides a wide array of fertilizers and agrochemical
            products that are essential for soil health and crop protection.
            These products are meticulously sourced and tested to ensure they
            meet the highest standards of quality and efficacy. Understanding
            that soil health is paramount to successful farming, Sonam Agrotech
            offers specialized soil fertilization services. These services are
            tailored to the specific needs of the soil, ensuring optimal
            nutrient balance and enhancing soil fertility. Beyond providing
            products, Sonam Agrotech offers a suite of services aimed at
            improving agricultural practices. This includes guidance on best
            farming practices, crop management, and pest control, helping
            farmers achieve better yields and improved crop quality. Sonam
            Agrotech is also dedicated to ensuring that farmers benefit from
            various government schemes aimed at agricultural development. The
            company actively assists farmers in understanding and accessing
            these schemes, which can provide financial support, subsidies, and
            technical assistance. By bridging the gap between government
            initiatives and farmers, Sonam Agrotech plays a crucial role in
            enhancing the economic well-being of the agricultural community. At
            the heart of Sonam Agrotech's operations is a commitment to quality
            and sustainability. The company employs rigorous quality control
            measures to ensure that all products meet stringent standards.
            Additionally, Sonam Agrotech promotes sustainable farming practices
            that protect the environment while maximizing productivity. This
            dual focus on quality and sustainability ensures long-term benefits
            for farmers and the broader ecosystem. Sonam Agrotech Private
            Limited is more than just a provider of agricultural products; it is
            a partner in progress for farmers. By offering high-quality
            fertilizers and agrochemicals, specialized soil fertilization
            services, and support for government schemes, Sonam Agrotech is
            dedicated to empowering farmers and enhancing agricultural
            productivity. As the company continues to grow, it remains committed
            to its mission of fostering sustainable and profitable farming
            practices, ensuring a brighter future for the agricultural community
            in Bihar and beyond.
          </Text>
        </Box>
        <Box
          p={"20px"}
          display={"flex"}
          flexDirection={["column", "column", "column", "row", "row"]}
          justifyContent="space-around"
          mt={"25px"}
          width={"100%"}
          height={["auto", "auto", "auto", "auto", "300px"]}
          borderRadius={"24px"}
          backgroundColor="#ECFFCF"
          boxShadow={" 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
        >
          <Box>
            <Text
              color={"#404040"}
              fontFamily="Inter"
              fontSize={["20px", "36px"]}
              fontWeight="700"
            >
              Vision
            </Text>
            <Image
              src={VisionImage}
              w={["100%", "256px"]}
              h={["200px", "200px"]}
            />
          </Box>
          <Box w={["auto", "auto", "auto", "auto", "830px"]}>
            <Text
              color={"#000000"}
              fontSize={["10px", "16px"]}
              fontWeight={"400"}
            >
              "To revolutionize Indian agriculture by empowering farmers with
              innovative, sustainable, and affordable agri-tech solutions that
              enhance productivity, promote eco-friendly practices, and
              contribute meaningfully to the nation’s food security. We envision
              a future where every farmer — regardless of region or landholding
              size — has access to world-class technologies, knowledge, and
              support systems that enable them to grow more with less. Our goal
              is to transform traditional farming into a smart, data-driven, and
              climate-resilient enterprise that ensures prosperity at the
              grassroots level. Through continuous innovation, education, and
              collaboration with rural communities, we aim to bridge the gap
              between modern science and traditional wisdom. At Sonam Agrotech,
              we believe that empowering the farmer means empowering the nation
              — and our vision is deeply rooted in building a greener,
              self-reliant, and food-secure India."{" "}
            </Text>
          </Box>
        </Box>

        <Box mt={"30px"}>
          <Text
            color={"#404040"}
            fontSize={["20px", "36px"]}
            fontWeight={"700"}
            textAlign="center"
          >
            Mission
          </Text>
          <Text
            color={"#000000"}
            textAlign="center"
            fontSize={["10px", "16px"]}
            fontWeight="400"
          >
            This is a sample text for mission
          </Text>
          <Box
            display="grid"
            gridTemplateColumns={[
              "1fr",
              "1fr",
              "repeat(2,1fr)",
              "repeat(2,1fr)",
              "repeat(3,1fr)",
            ]}
            gap="16px"
            mt="40px"
          >
            {missions.map((mission, index) => (
              <Box
                key={index}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                borderRadius="24px"
                backgroundColor={mission.bg}
                boxShadow="0px 4px 12px rgba(0, 0, 0, 0.15)"
                transition="all 0.3s ease"
                _hover={{ transform: "scale(1.02)" }}
                p={[4, 6]}
              >
                <Image src={MissionIcon} w={["18%", "auto"]} mt="10px" />
                <Text
                  color="#1A1A1A"
                  fontSize={["18px", "28px"]}
                  fontWeight="700"
                  textAlign="center"
                  mt="10px"
                >
                  {mission.title}
                </Text>
                <Text
                  color="#000000"
                  fontSize={["12px", "16px"]}
                  fontWeight="400"
                  mt="10px"
                  textAlign="center"
                >
                  {mission.text}
                </Text>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      <Box
        w={"100%"}
        h={["auto", "auto", "auto", "auto", "830px"]}
        background="#404040"
      >
        <Box ml={"6%"} mt={["10px", "30px"]} pt={["10px", "40px"]}>
          <Text
            color={"#FFFFFF"}
            fontSize={["20px", "36px"]}
            fontWeight={"700"}
          >
            Meet our
          </Text>
          <Text
            color={"#FFFFFF"}
            fontSize={["30px", "48px"]}
            fontWeight={"700"}
          >
            Founders
          </Text>
        </Box>
        <Box
          display={"grid"}
          gridTemplateColumns={[
            "repeat(2,1fr)",
            "auto",
            "auto",
            "auto",
            "repeat(2,629px)",
          ]}
          justifyContent="space-around"
          p={["10px", "40px"]}
        >
          <Box backgroundColor={"#D9D9D9"}>
            <Box>
              <Image
                src={image2}
                w={"auto"}
                m={"auto"}
                // w={["100%","629px"]}
                h={["50%", "419px"]}
              />
            </Box>
            <Box p={["10px", "20px"]}>
              <Text
                color={"#000000"}
                fontSize={["20px", "32px"]}
                fontWeight={"700"}
              >
                Kumar Aditya
              </Text>
              <Text
                color={"#000000"}
                fontSize={["10px", "22px"]}
                fontWeight={"700"}
              >
                Director (CEO)
              </Text>
            </Box>
          </Box>
          <Box backgroundColor={"#D9D9D9"}>
            <Box>
              <Image src={pallavi} m={"auto"} w="auto" h={["50%", "419px"]} />
            </Box>
            <Box p={["10px", "20px"]}>
              {" "}
              <Text
                color={"#000000"}
                fontSize={["20px", "32px"]}
                fontWeight={"700"}
              >
                Pallavi Jain
              </Text>
              <Text
                color={"#000000"}
                fontSize={["10px", "22px"]}
                fontWeight={"700"}
              >
                CTO
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default About;
